import { UiAccordionModel } from "../../models";

export function mockUiAccordionModel({
    id = "accordion-1234",
    type = "uiAccordion",
    locale = "en",
    content = mockUiAccordionModelContent()
}: Partial<UiAccordionModel> = {}): UiAccordionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiAccordionModelContent = UiAccordionModel["content"];

export function mockUiAccordionModelContent({
    title = "Example Accordion",
    appearance = "List",
    ...optionals
}: Partial<UiAccordionModelContent> = {}): UiAccordionModelContent {
    return {
        title,
        appearance,
        ...optionals
    };
}
